import React, { useState } from "react";

import CardAiModelTable from "components/Cards/CardAiModelTable.js";
import CardAiModelForm from "components/Cards/CardAiModelForm.js";

export default function AiModels() {
  const [selectedModel, setSelectedModel] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEditModel = (model) => {
    setSelectedModel(model);
    setIsFormOpen(true);
  };

  const handleNewModel = () => {
    setSelectedModel(null);
    setIsFormOpen(true);
  };

  const handleFormSave = () => {
    setIsFormOpen(false);
    setSelectedModel(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleFormCancel = () => {
    setIsFormOpen(false);
    setSelectedModel(null);
  };

  const handleModelDeleted = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <CardAiModelTable
            key={refreshTrigger}
            onEditModel={handleEditModel}
            onDeleteModel={handleModelDeleted}
            onNewModel={handleNewModel}
          />
        </div>
      </div>

      <CardAiModelForm
        model={selectedModel}
        isOpen={isFormOpen}
        onSave={handleFormSave}
        onCancel={handleFormCancel}
      />
    </>
  );
}
